import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

orderHistoryTableStyles.reorderButton = mergeToNew(orderHistoryTableStyles.reorderButton, {
    css: css`
        background-color: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        margin-top: 10px;
        margin-bottom: 10px;
        border-radius: 0px;
        :hover {
            border: 2px solid ${getColor("text.accent")};
            background-color: ${getColor("text.accent")};
        }
    `,
});
orderHistoryTableStyles.dataTable = mergeToNew(orderHistoryTableStyles.dataTable, {
    css: css`
        button {
            justify-content: center;
        }
    `,
});

orderHistoryTableStyles.orderNumberHeader = mergeToNew(orderHistoryTableStyles.orderNumberHeader, {
    css: css`
        button {
            > span {
                color: ${getColor("primary")}!important;
                white-space: nowrap;
            }
        }
    `,
});

orderHistoryTableStyles.orderDateHeader = mergeToNew(orderHistoryTableStyles.orderDateHeader, {
    css: css`
        button {
            > span {
                color: ${getColor("primary")} !important;
                white-space: nowrap;
            }
        }
    `,
});

orderHistoryTableStyles.orderTotalHeader = mergeToNew(orderHistoryTableStyles.orderTotalHeader, {
    css: css`
        button {
            > span {
                color: ${getColor("primary")} !important;
                white-space: nowrap;
            }
        }
    `,
});

orderHistoryTableStyles.statusHeader = mergeToNew(orderHistoryTableStyles.statusHeader, {
    css: css`
        button {
            > span {
                color: ${getColor("primary")} !important;
                white-space: nowrap;
            }
        }
    `,
});

orderHistoryTableStyles.shipToHeader = mergeToNew(orderHistoryTableStyles.shipToHeader, {
    css: css`
        button {
            > span {
                color: ${getColor("primary")} !important;
            }
        }
    `,
});

orderHistoryTableStyles.customerPOHeader = mergeToNew(orderHistoryTableStyles.customerPOHeader, {
    css: css`
        button {
            > span {
                color: ${getColor("primary")} !important;
                white-space: nowrap;
            }
        }
    `,
});

orderHistoryTableStyles.reorderHeader = mergeToNew(orderHistoryTableStyles.reorderHeader, {
    css: css`
        button {
            > span {
                color: ${getColor("primary")} !important;
                white-space: nowrap;
            }
        }
    `,
});

orderHistoryTableStyles.orderNumberCells = mergeToNew(orderHistoryTableStyles.orderNumberCells, {
    css: css`
        a {
            span {
                color: ${getColor("text.link")};
            }
            :hover {
                text-decoration: underline;
            }
        }
    `,
});

orderHistoryTableStyles.orderDateCells = mergeToNew(orderHistoryTableStyles.orderDateCells, {
    css: css`
        span {
            color: ${getColor("primary")};
        }
    `,
});
orderHistoryTableStyles.orderTotalCells = mergeToNew(orderHistoryTableStyles.orderTotalCells, {
    css: css`
        span {
            color: ${getColor("primary")};
        }
    `,
});
orderHistoryTableStyles.statusCells = mergeToNew(orderHistoryTableStyles.statusCells, {
    css: css`
        span {
            color: ${getColor("primary")};
        }
    `,
});
orderHistoryTableStyles.shipToCells = mergeToNew(orderHistoryTableStyles.shipToCells, {
    css: css`
        span {
            color: ${getColor("primary")};
        }
    `,
});
orderHistoryTableStyles.customerPOCells = mergeToNew(orderHistoryTableStyles.customerPOCells, {
    css: css`
        span {
            color: ${getColor("primary")};
        }
    `,
});
